module.exports = __webpack_public_path__ + "static/14-d9fa3965d4a580677572d8a58e161078.png";